import { Badge } from '@mui/material';
import React from 'react';

export default function UpdateBadge(props: { children: React.ReactNode, seenAt: number, badgeContent: number, updatedAt?: number, disabled?: boolean }) {
  const {
    children, seenAt, updatedAt, disabled, badgeContent,
  } = props;
  if (!updatedAt || disabled) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }
  if (updatedAt > seenAt) {
    return (
      <Badge badgeContent={badgeContent} color="error" variant="standard" anchorOrigin={{ horizontal: 'right', vertical: 'top' }}>
        {children}
      </Badge>
    );
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
